import { Link } from 'react-router-dom';
import '../styles/platform.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

function Uxboard() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="uxboard-banner" className="ux-banner">
        <div
          className="m-auto banner-container"
          data-aos="fade-right"
          data-aos-duration="700"
          data-aos-once="true"
        >
          <div className="mb-32">
            <img src="./images/logo-uxboard.svg" alt="uxboardlogoimage" />
          </div>
          <p
            className="fs-md fw-bold mb-24"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="100"
          >
            종합적인 업무관리 및 실적 정보를
            <br />
            한눈에 파악할 수 있는 대시보드 구축 서비스
          </p>
          <p
            className="fs-base mb-60"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="200"
          >
            주요 실적 지표 데이터를 실시간으로 시각화하는 시스템으로&nbsp;
            <br className="mo-none" />
            이를 통해 웹사이트의 접근성과 사용자 만족도를 향상시킬 수 있습니다.
          </p>
          <ul
            className="ux-button"
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <li>
              <Link to="/contact?service=uxboard&no=02" className="btn-outline fw-bold">
                소개자료 문의
              </Link>
            </li>
            <li>
              <Link to="/contact?service=uxboard&no=01" className="btn-filled fw-bold">
                서비스 도입 문의
              </Link>
            </li>
          </ul>
        </div>
      </section>
      <section id="uxboard-intro">
        <div className="m-auto content-padding">
          <h3 className="ux-content-title">
            <strong>UXBoard</strong> 를 사용해야 하는 이유
          </h3>
          <div className="content-bg content-gap reason02-container">
            <div className="content-box ux-boxbar-x reason02-box">
              <ul>
                <li>
                  <img src="./images/ico-uxboard-reason01.svg" alt="" />
                  <p className="fs-base fw-md">데이터 가시화</p>
                  <p className="color-caption">
                    주요 데이터에 대한 직관적 파악을 위해
                    <br />
                    데이터를 시각화 하여 제공
                  </p>
                </li>
                <li>
                  <img src="./images/ico-uxboard-reason02.svg" alt="" />
                  <p className="fs-base fw-md">실시간 데이터 모니터링</p>
                  <p className="color-caption">
                    최신 데이터를 실시간 반영하여
                    <br />
                    비즈니스 변화에 신속한 대응
                  </p>
                </li>
                <li>
                  <img src="./images/ico-uxboard-reason03.svg" alt="" />
                  <p className="fs-base fw-md">효율적인 의사결정</p>
                  <p className="color-caption">
                    필요한 정보를 빠르게 확인하고
                    <br />
                    의사결정에 대한 적시성 확보
                  </p>
                </li>
                <li>
                  <img src="./images/ico-uxboard-reason04.svg" alt="" />
                  <p className="fs-base fw-md">성과 추적</p>
                  <p className="color-caption">
                    주요 성과 지표를 모니터링하여
                    <br />
                    목표 대비 진행 상황 추적
                  </p>
                </li>
              </ul>
            </div>
            <div className="arrow">
              <img src="./images/ux-arrow.svg" alt="아래화살표" />
            </div>
            <div className="reason02-fin fs-md fw-bold">업무 효율 향상 및 빠른 의사결정</div>
          </div>
          <h3 className="ux-content-title02">
            <strong>UXBoard</strong> 만의 특장점
          </h3>
          <p className="fs-md content-subtitle text-center">
            주요 핵심 정보들을 통합한 대시보드 구축으로
            <br className="pc-none" />
            시각화 · 전산화 효과에 최적화된 UXBoard
          </p>
          <div className="content-bg uxboard-strength-container">
            <div className="uxboard-strength-content">
              <div className="uxboard-strength-box content-box ux-boxbar-x">
                <div className="uxboard-image-box">
                  <img src="./images/img-uxboard-dash01.svg" alt="" />
                </div>
                <p className="text-center color-uxb fs-base fw-bold">
                  차트 연동을 통한
                  <br />
                  데이터 상관관계 빠른 식별 가능
                </p>
                <ul>
                  <li className="text-dot">상용차트/오픈소스 차트 지원</li>
                  <li className="text-dot">항목별 특성에 맞는 차트 연동</li>
                  <li className="text-dot">통계 데이터에 대한 빠른 탐색</li>
                </ul>
              </div>
              <div className="uxboard-strength-box content-box ux-boxbar-x">
                <div className="uxboard-image-box">
                  <img src="./images/img-uxboard-dash02.svg" alt="" />
                </div>
                <p className="text-center color-uxb fs-base fw-bold">
                  콘텐츠 관리를 통한
                  <br />
                  실시간 동향 파악 및 성과지표 측정
                </p>
                <ul>
                  <li className="text-dot">대시보드 콘텐츠 관리 기능</li>
                  <li className="text-dot">권한별 콘텐츠 설정</li>
                  <li className="text-dot">콘텐츠 사이즈별 등록 가능</li>
                </ul>
              </div>
              <div className="uxboard-strength-box content-box ux-boxbar-x">
                <div className="uxboard-image-box">
                  <img src="./images/img-uxboard-dash03.svg" alt="" />
                </div>
                <p className="text-center color-uxb fs-base fw-bold">
                  포괄적 뷰를 통한
                  <br />
                  중요 정보 파악 및 신속한 의사결정
                </p>
                <ul>
                  <li className="text-dot">개인/부서/업무별 콘텐츠 구성</li>
                  <li className="text-dot">슬라이드 형태로 다중 페이지 구성 가능</li>
                  <li className="text-dot">진행상황에 대한 포괄적 분석에 용이</li>
                </ul>
              </div>
            </div>
            <div className="uxboard-strength-box02 content-box flex">
              <div className="uxboard-strength-item01">
                <p className="fs-base fw-bold mb-8">차트 연동 사례</p>
                <ul>
                  <li className="text-dot">입고/출고/재고 현황</li>
                  <li className="text-dot">주문대비 출고 현황</li>
                </ul>
                <ul>
                  <li className="text-dot">일자별 대상건수 현황</li>
                  <li className="text-dot">지역별 정보 현황</li>
                </ul>
              </div>
              <div className="uxboard-strength-item02">
                <p className="fs-base fw-bold mb-8">업무별 활용 사례</p>
                <ul>
                  <li className="text-dot">재무제표</li>
                  <li className="text-dot">제품 입고</li>
                  <li className="text-dot">판매 실적</li>
                  <li className="text-dot">클레임 현황</li>
                </ul>
                <ul>
                  <li className="text-dot">생산 현황</li>
                  <li className="text-dot">인원 현황</li>
                  <li className="text-dot">재고 현황</li>
                  <li className="text-dot">품질 현황</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="uxboard-workflow">
        <div className="m-auto content-padding">
          <p className="color-uxb fs-base fw-bold mb-8">WORK FLOW</p>
          <h3 className="ux-content-title">
            <strong>UXBoard</strong> Process
          </h3>
          <div className="img-uxboard-process">
            <img src="./images/img-uxboard-process.svg" alt="uxboard-process" />
          </div>
          <div className="img-uxboard-process-mo">
            <img src="./images/img-uxboard-process-mo.svg" alt="uxboard-process" />
          </div>
          <h3 className="ux-content-title mt-100">
            <strong>UXBoard</strong> 구축 상세과정
          </h3>
          <div className="img-uxboard-process">
            <img src="./images/img-uxboard-process02.svg" alt="uxboard 과정" />
          </div>
          <div className="img-uxboard-process-mo">
            <img src="./images/img-uxboard-process02-mo.svg" alt="uxboard 구축 상세과정" />
          </div>
        </div>
      </section>
      <section id="uxboard-effect">
        <div className="m-auto content-padding">
          <h3 className="ux-content-title">
            <strong>UXBoard</strong> 도입 기대효과
          </h3>
          <div className="uxbooster-effect-container">
            <div className="uxboard-effect-content">
              <div className="content-box ux-boxbar-x uxboard-effect-box">
                <img src="./images/ico-uxboard-effect01.svg" alt="경영진기대효과아이콘" />
                <p className="color-uxb fs-md fw-bold">경영진</p>
                <ul>
                  <li className="text-dot fs-base">데이터 기반 전략적인 의사결정 지원</li>
                  <li className="text-dot fs-base">중장기적 목표 및 성과 모니터링</li>
                  <li className="text-dot fs-base">빠른 비즈니스 성장 및 민첩성 증대</li>
                </ul>
              </div>
              <div className="content-box ux-boxbar-x uxboard-effect-box">
                <img src="./images/ico-uxboard-effect02.svg" alt="팀별기대효과아이콘" />
                <p className="color-uxb fs-md fw-bold">팀별</p>
                <ul>
                  <li className="text-dot fs-base">정략적 수치를 통한 조직의 KPI 관리</li>
                  <li className="text-dot fs-base">목표 달성을 위한 실시간 성과 추적</li>
                  <li className="text-dot fs-base">정확한 데이터를 근거로 협업 향상</li>
                </ul>
              </div>
              <div className="content-box ux-boxbar-x uxboard-effect-box">
                <img src="./images/ico-uxboard-effect01.svg" alt="개인별기대효과아이콘" />
                <p className="color-uxb fs-md fw-bold">개인별</p>
                <ul>
                  <li className="text-dot fs-base">업무 효율성 향상</li>
                  <li className="text-dot fs-base">업무 핵심 정보 제공</li>
                  <li className="text-dot fs-base">일관된 데이터로 의사소통 능력 확대</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="ux-contact">
        <div className="contact-container m-auto">
          <div
            className="contact-text"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
          >
            <p className="fs-xxl">지금 바로</p>
            <img src="./images/logo-uxboard-white.svg" alt="uxboard-logo" />
            <p className="fs-xxl">를 만나보세요!</p>
          </div>
          <div
            className="contact-button fs-base"
            data-aos="fade-up"
            data-aos-duration="400"
            data-aos-once="true"
            data-aos-delay="300"
          >
            <Link to="/contact?service=uxboard&no=01" className="color-uxb">
              서비스 도입 문의
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Uxboard;
